import { render, staticRenderFns } from "./riskWarning.vue?vue&type=template&id=7be9d4cc"
import script from "./riskWarning.vue?vue&type=script&lang=js"
export * from "./riskWarning.vue?vue&type=script&lang=js"
import style0 from "./riskWarning.vue?vue&type=style&index=0&id=7be9d4cc&prod&lang=scss"
import style1 from "./riskWarning.vue?vue&type=style&index=1&id=7be9d4cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports